import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { setUserInfoToSession } from '../Services/session.mgmt';
import axios from 'axios';
import authService from '../Services/AuthService';
import Unauthorized from '../Pages/Unauthorized/Unauthorized';
import _ from 'lodash';
import { profileService } from '../Services/ProfileService';
import { formatDate, addMonths } from 'date-fns';
import { DATE_FORMAT } from '../constants/RepoReactConstants';

const AuthLoginCallback = () => {
  const navigate = useNavigate();
  const [loadingUserInfo, setLoadingUserInfo] = useState(true);
  const [unAuthorized, setUnAuthorized] = useState(false);
  const currentDate = formatDate(new Date(), DATE_FORMAT);

  function divertUserPath(userInfo) {
    setLoadingUserInfo(false);
    if (userInfo.isAdmin && !userInfo.isExternal) {
      navigate('/userVerification');
    } else if (userInfo.hasContractProfile) {
      navigate('/misc');
    } else {
      setUnAuthorized(true);
    }
  }

  function handleError(errResp) {
    setLoadingUserInfo(false);
    setUnAuthorized(true);
    if (errResp.response && (errResp.response.status === 401 || errResp.response.status === 400)) {
      const callbackUrl = `${window.location.origin}/auth-callback`;
      const authUrl = `${process.env.REACT_APP_GATEWAY_URL}${process.env.REACT_APP_USER_GATEWAY_PATH}/auth/login?homePage=${encodeURIComponent(callbackUrl)}`;
      window.location.assign(authUrl);
    }
  }

  // ✅ useEffect is NOT async — inner function handles async work
  useEffect(() => {
    function renderExternalUser(response) {
      const userInfo = {
        userid: response.data.accessToken.userid?.trim(),
        sitecode: response.data.accessToken.sitecode,
      };
      authService
        .isExternalUser(userInfo.sitecode)
        .then((externalUserResp) => {
          if (externalUserResp?.data) {
            userInfo['isExternal'] = true;
            userInfo.userid = _.trim(externalUserResp?.data.result);
          } else {
            userInfo['isExternal'] = false;
          }
          callPromiseAll(userInfo);
        })
        .catch((errResp) => {
          handleError(errResp);
        });
    }

    async function callPromiseAll(userInfo) {
      Promise.all([authService.isAdminUser(userInfo.userid), authService.getUserDetail(userInfo.userid)])
        .then(async ([adminUserResp, userDetailResp]) => {
          userInfo['isAdmin'] = !!adminUserResp.data;
          userInfo['hasContractProfile'] = userDetailResp?.data.length > 0;
          userInfo['cntrctrNb'] = userDetailResp?.data[0]?.cntrctrNb;
          console.log('isEmpty(userDetailResp?.data): TRUE = ' + !_.isEmpty(userDetailResp?.data));
          if (!_.isEmpty(userDetailResp?.data)) {
            const contractorDetail = await profileService.getContractorPersonal(userDetailResp.data[0].cntrctrNb);
            console.log(
              'isEmpty(userDetailResp?.data):TRUE = ' + !_.isEmpty(contractorDetail.data.result.cntrctrData2ApiList)
            );
            if (!_.isEmpty(contractorDetail.data.result.cntrctrData2ApiList)) {
              userInfo['buzLcnsExpireDate'] =
                contractorDetail.data.result.cntrctrData2ApiList[0].busLcnsExpirDt || currentDate;
              userInfo['insuranceExpireDate'] =
                contractorDetail.data.result.cntrctrData2ApiList[0].insInfoExpirDt || currentDate;
              userInfo['countryCd'] = contractorDetail.data.result.cntrctrData2ApiList[0].cntryCd;
              setUserInfoToSession(userInfo);
            }
          } else if (userInfo.isAdmin) {
            userInfo['buzLcnsExpireDate'] = formatDate(addMonths(new Date(), 12), DATE_FORMAT);
            userInfo['insuranceExpireDate'] = formatDate(addMonths(new Date(), 12), DATE_FORMAT);
          } else {
            console.log('User profile missing buzLcnsExpireDate and insuranceExpireDate');
          }
          if (userInfo.isAdmin || !_.isEmpty(userDetailResp.data)) {
            setUserInfoToSession(userInfo);
            divertUserPath(userInfo);
            setLoadingUserInfo(false);
          } else {
            setLoadingUserInfo(false);
            setUnAuthorized(true);
          }
        })
        .catch((reason) => {
          console.log('AuthLoginCallback.retrieveUserInfo Failed: ' + reason.toString());
          setLoadingUserInfo(false);
          setUnAuthorized(true);
        })
        .finally(() => {
          console.log('AuthLoginCallback.retrieveUserInfo Completed with : ' + JSON.stringify(userInfo));
        });
    }

    console.log('process.env.REACT_APP_SERVICE_BASE_URL : ' + process.env.REACT_APP_SERVICE_BASE_URL);

    async function init() {
      try {
        let authUserInfoResponse = await axios.get(
          `${process.env.REACT_APP_GATEWAY_URL}${process.env.REACT_APP_USER_GATEWAY_PATH}/auth/userInfo`,
          { withCredentials: true }
        );
        if (!!authUserInfoResponse && !authUserInfoResponse.data) {
          authUserInfoResponse = await axios.get(`${process.env.REACT_APP_GATEWAY_URL}/auth/userInfo`, {
            withCredentials: true,
          });
        }
        if (authUserInfoResponse?.data) {
          console.log(' authUserInfoResponse :: ' + JSON.stringify(authUserInfoResponse));
          renderExternalUser(authUserInfoResponse);
        } else {
          setLoadingUserInfo(false);
          setUnAuthorized(true);
        }
      } catch (err) {
        console.error('Failed to get user info:', err);
        handleError(err);
      }
    }

    init(); // ✅ called without await — no Promise returned to useEffect
  }, []);

  if (loadingUserInfo) return <>loading...</>;
  if (unAuthorized) return <Unauthorized />;
  return (
    <div>
      <h2>Get User Token from Server...</h2>
    </div>
  );
};

export default AuthLoginCallback;
